<template>
  <div class="details">
    <navigation :loggedIn="loggedIn"/>
    <v-row class="details__content">
      <v-col cols="4" class="details__summary">
        <router-link class="details__navigation" to="/" tag="span" style="cursor: pointer">
          <span>&lt; Database</span> /
          <span class="details__navigation-company-name">
            {{ company.name }}</span>
        </router-link>
        <detail-summary-card :company="company" />
      </v-col>

      <v-col cols="8" class="details__pricing">
        <div class="details__pricing-card details__pricing-card--latest">
          <h1 class="details__pricing-card-title">Latest Pricing Page</h1>
          <v-img class="details__pricing-card-image" max-width="620px" height="450px"
            :src="latestImageDomain + company.filename" alt="pricing page">
            <template :slot="'default'">
              <div class="details__pricing-card-image-expand">
                <icon-expand />
              </div>
            </template>
          </v-img>
        </div>
        <div class="details__pricing-card details__pricing-card--old" v-for="(oldDate, index) in oldDirectories"
          :key="index">
          <h1 class="details__pricing-card-title">Pricing page {{ oldDate.date.year() }}</h1>

          <p class="details__pricing-card-description">
            {{ getCapturedText(oldDate.date) }}
          </p>
          <v-img class="details__pricing-card-image" max-width="620px" height="450px" src="@/assets/blurred.png"
            alt="pricing page" v-if="!loggedIn" />
          <v-img class="details__pricing-card-image" max-width="620px" height="450px"
            :src="baseImageDomain + oldDate.text + '/' + company.filename" alt="pricing page" v-else />
        </div>

      </v-col>
    </v-row>
    <detail-page-footer v-if="!loggedIn"/>
    <conversion-popup :show.sync="showConversionPopup" />
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Navigation from "@/components/Navigation";
import DetailPageFooter from "@/components/DetailPageFooter";
import DetailSummaryCard from "@/components/DetailSummaryCard";
import IconExpand from "@/components/icons/IconExpand";
import ConversionPopup from "../components/ConversionPopup";
import moment from 'moment';
import VueCookies from 'vue-cookies';
import Meta from 'vue-meta';

Vue.prototype.moment = moment;
Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(Meta);


export default {
  components: {
    Navigation,
    DetailPageFooter,
    DetailSummaryCard,
    IconExpand,
    ConversionPopup
  },
  name: "Details",
  metaInfo() {
    return {
      title: "SaaS Pricing Pages - Pricing history for " + this.$route.params.company,
    }
  },
  data: () => ({
    companyName: "",
    company: {},
    curPlans: {},
    plan: {},
    curDirectories: {},
    oldDirectories: [],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    hash: "",
    loggedIn: false,
    showConversionPopup: false
  }),
  created() {
    this.companyName = this.$route.params.company;
  },
  mounted() {
    // this.getCompanyInfo();
    if (this.$cookies.get("detailsCount") == null) {
      this.$cookies.set("detailsCount", 0, -1);
    }
    this.checkHash();
  },
  computed: {
    latestImageDomain() {
      return process.env.VUE_APP_SCREENSHOTSURL + "latest/";
    },
    baseImageDomain() {
      return process.env.VUE_APP_SCREENSHOTSURL;
    }
  },
  watch: {},
  methods: {
    checkHash() {
      // console.log('hash ', this.$route.params.hash);
      this.loggedIn = false;
      if (typeof (this.$route.params.hash) == 'undefined') {
        // this.enableConversionPopup();
        this.getCompanyInfo();
        this.enableConversionPopup();
      }
      Vue.axios
        .post("getemail", {
          hash: this.$route.params.hash
        })
        .then(response => {
          if (
            response.data.status == "success" 
          ) {
            this.loggedIn = true;
            this.disableConversionPopup();
            this.getCompanyInfo();
          } else {
            this.getCompanyInfo();
            this.enableConversionPopup();
          }
        })
        .catch(() => {
          // console.log(error);
          this.getCompanyInfo();
          this.enableConversionPopup();
        });
    },
    getCapturedText(oldDate) {
      var curDate = moment();
      var diff = curDate.diff(oldDate, 'years');
      if (diff > 1) {
        return 'Screenshot captured ' + diff + ' years ago';
      } else {
        return 'Screenshot captured ' + curDate.diff(oldDate, 'months') + ' months ago';
      }
    },
    getCompanyInfo() {
      // console.log(this.companyName);
      Vue.axios
        .get("companies/byname/" + this.companyName)
        .then(response => {
          this.company = response.data.data;
          // console.log(this.company);
          Vue.axios
            .get("companies/plans/" + this.company.id)
            .then(response => {
              this.curPlans = response.data.data;
              this.plan = this.curPlans[0];
              // console.log(this.curPlans);
            })
            .catch(error => {
              console.log(error);
              this.curPlans = {};
            });
          Vue.axios
            .get("companies/screenshots/" + this.company.id)
            .then(response => {
              this.curDirectories = response.data.data;
              var curDate = moment();
              for (var i = 0; i < this.curDirectories.length; i++) {
                if (this.curDirectories[i] != 'latest') {
                  var oldDate = moment(this.curDirectories[i], 'MM-YYYY');
                  var difference = moment(curDate).diff(oldDate, 'months', true);
                  Vue.set(this.oldDirectories, i, {
                    text: this.curDirectories[i],
                    date: oldDate,
                    timeSince: difference
                  })
                  // this.oldDirectories[i] = {
                  //   text: this.curDirectories[i],
                  //   date: oldDate,
                  //   timeSince: difference
                  // }
                }
              }
              // console.log(this.curDirectories);
            })
            .catch(error => {
              console.log(error);
              this.curDirectories = {};
            });
        })
        .catch(error => {
          console.log(error, 'no company');
          this.$router.push({ path: '/error' })
          // this.company = {};
          // this.curPlans = {};
        });
    },
    enableConversionPopup() {
      var count = Number(this.$cookies.get('detailsCount'));
      if(count < 10) {
        this.$cookies.set('detailsCount', count + 1);
        return;
      }
      setTimeout(() => {
        this.showConversionPopup = true;
      }, 3000);
    },
    disableConversionPopup() {
      setTimeout(() => {
        this.showConversionPopup = false;
      }, 500);
    }
  }
};
</script>
<style>
.v-image__image--cover {
  background-position: top center !important;
}

.details__content {
  padding: 26px 24px 48px 24px;
  margin: 0;
}

.details__navigation {
  display: block;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #030134;
  margin-bottom: 50px;
}

.details__navigation-company-name {
  text-decoration: underline;
  text-decoration-color: #f6c1c0;
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
}

.details__pricing-card-image {
  max-width: 600px;
  height: auto;
  border: 1px solid #dddddd;
  border-radius: 12px;
}

.details__summary {
  padding-right: 50px;
  max-width: 400px;
  min-width: 320px;
}

.details__pricing {
  max-width: 620px;
  padding-right: 0;
}

.details__summary,
.details__pricing {
  padding-top: 0;
  padding-left: 0;
}

.details__pricing-card:not(:last-child) {
  margin-bottom: 48px;
}

.details__pricing-card:first-child .details__pricing-card-title {
  font-size: 42px;
}

.details__pricing-card-title {
  font-weight: 600;
  font-size: 26px;
  line-height: 1.5;
  letter-spacing: -0.5px;
  color: #222049;
  margin-bottom: 24px;
}

.details__pricing-card-description {
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  color: #030134;
  margin-bottom: 8px !important;
}

.details__pricing-card-image-expand {
  position: absolute;
  bottom: -7px;
  right: 0;
}

.details__pricing-card:not(:first-child) .details__pricing-card-image .v-image__image {
  /* filter: blur(16px); */
}

@media (max-width: 1003px) {
  .details__navigation {
    margin-bottom: 30px;
  }

  .details__summary {
    padding-right: 0px;
    margin-bottom: 30px;
  }
}

@media (max-width: 470px) {
  .details__navigation {
    margin-bottom: 30px;
  }

  .details__summary {
    padding-right: 0px;
    margin-bottom: 30px;
  }

  .details__pricing-card:first-child .details__pricing-card-title,
  .details__pricing-card-title {
    font-size: 28px;
    margin-bottom: 15px;
  }

  .details__pricing-card-description {
    margin-bottom: 15px !important;
  }
}
</style>
